export const SecurityPrinciples = {
    confidentiality: "Confidentiality",
    integrity: "Integrity",
    availability: "Availability",
    accountability: "Accountability",
    authenticity: "Authenticity"
}